import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SymbolPickerComponent } from 'projects/shared-components/symbol-picker/symbol-picker.component';
import { isTruthy } from 'projects/shared-components/utils';
import { EditStrategyDialogComponent } from '../../../edit-strategy-dialog.component';
import { ParametersViewBase } from '../../parameters-view-base';
import { DynamicHedgeAlgoParametersControl } from './dynamic-hedge-algo-parameters-control';

@Component({
   selector: 'ets-dynamic-hedge-parameters-view',
   templateUrl: './dynamic-hedge-parameters-view.component.html',
   styleUrls: ['./dynamic-hedge-parameters-view.component.scss']
})
export class DynamicHedgeParametersViewComponent extends ParametersViewBase<DynamicHedgeAlgoParametersControl> {
   
   @ViewChild(SymbolPickerComponent, { static: true }) symbolPicker: SymbolPickerComponent;
   
   onEtsInit() { }
   
   onEtsAfterViewInit() { }
}
